import { makeObservable } from 'mobx';

import { SubscriptionOrderData, type SubscriptionOrderListQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

interface FilterParams extends SubscriptionOrderListQuery {}

export class SubscriptionOrdersList extends LongList<SubscriptionOrderData, SubscriptionOrderData, FilterParams> {
    constructor(params?: SubscriptionOrderData[]) {
        super(params);
        makeObservable(this);
    }

    protected create(params: SubscriptionOrderData): SubscriptionOrderData {
        return params;
    }
}
